export default __webpack_public_path__ + "images/assets/af0f29ee25ae6ff7918634a11d54dbd6.svg";